/**
 * PageFooterBottom
 */
import React from 'react';
import clsx from 'clsx';
/** Main description for this component. */
var PageFooterBottom = function (_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("div", { className: clsx(className, 'py-2 mt-6 bg-greySemiLight pt-4 lg:pt-0') }, children));
};
export default PageFooterBottom;
